import templateUrl from "emun.showroom/showmode-prompt.htm";
import controller from "emun.showroom/showmode-prompt.controller";
import open from "webmodals/open";

export default ({
  size = "md",
  backdrop = true,
  keyboard = true,
  title = "Choose Show Code..."
}) =>
  open({
    size,
    backdrop,
    keyboard,
    templateUrl,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      title: () => title
    }
  }).result;
